import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { Breadcrumbs, ContainerHeader, variantActionsProps } from 'shared/ui'
import {
  BroadcastErrorAlert,
  BroadcastRecurring,
  BroadcastRecurringLabel,
  BroadcastStatus,
  BroadcastType,
} from 'entities/Broadcast'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { type BroadcastDetailOneTimeStore } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime'
import { type BroadcastDetailRecurringStore } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring'
import { getBroadcastActions } from 'pages/broadcasts/ui/BroadcastActions'
import styles from './styles.module.scss'

type IBroadcastDetailHeaderProps = {
  store: BroadcastDetailOneTimeStore | BroadcastDetailRecurringStore
}

export const BroadcastDetailHeader: FC<IBroadcastDetailHeaderProps> = observer(({ store }) => {
  const { name, status, type, broadcast, failed_reason, pageLayoutStore } = store
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore
  const navigate = useNavigate()

  const onSuccessDelete = () => {
    navigate(`${BroadcastsRoutes.root}/${BroadcastsRoutes.all}`)
  }

  return (
    <div>
      <Breadcrumbs />
      <ContainerHeader
        paddingTop={16}
        paddingBottom={12}
        title={name}
        titleVariant={'heading-md'}
        actionsProps={{
          ...variantActionsProps['headerMedium'],
          actions: getBroadcastActions({
            broadcast,
            onSuccessDelete,
            filter: 'filter' in store ? store.filter : undefined,
          }),
        }}
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        paddingLeft={20}
        ellipsis
      />
      <div className={styles.info}>
        {broadcast instanceof BroadcastRecurring && (
          <BroadcastRecurringLabel broadcast={broadcast} />
        )}
        <BroadcastStatus status={status} />
        <BroadcastType type={type} />
      </div>
      {['failed', 'invalid'].includes(status) && (
        <div className={styles.alert}>
          <BroadcastErrorAlert failed_reason={failed_reason} />
        </div>
      )}
    </div>
  )
})
